import { render, staticRenderFns } from "./BenefitCard.vue?vue&type=template&id=6198a9b6&scoped=true&"
import script from "./BenefitCard.vue?vue&type=script&lang=js&"
export * from "./BenefitCard.vue?vue&type=script&lang=js&"
import style0 from "./BenefitCard.vue?vue&type=style&index=0&id=6198a9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198a9b6",
  null
  
)

export default component.exports